module.exports = __webpack_public_path__ + "media/src/assets/images/arrow_b_grad-ae5956c189460b080c54fae7830a8bb1.png";